module.exports = __webpack_public_path__ + "static/media/olake-nav-inactive.0ed03aa9.svg";